import { Routes } from '@dtx-company/true-common/src/constants/routes'

export function useDefaultPathname(): Routes.HOME {
  return Routes.HOME
}
